import { createFileRoute } from '@tanstack/react-router';

import { requireOwnerOrAdmin } from '~/lib/route-auth';
import { BinPageComponent } from '~/page-components/bin-page';

export const Route = createFileRoute('/bin')({
  beforeLoad: async () => {
    await requireOwnerOrAdmin();
  },
  component: BinPageComponent
});
